import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createCommentVNode as _createCommentVNode, vShow as _vShow, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "nav nav-tabs mt-2" }
const _hoisted_3 = { class: "nav-item" }
const _hoisted_4 = { class: "nav-item" }
const _hoisted_5 = { class: "pt-2" }
const _hoisted_6 = { class: "text-muted small mb-3" }
const _hoisted_7 = { class: "row mt-2" }
const _hoisted_8 = {
  for: "tgReceiptForwardGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-8" }
const _hoisted_10 = { class: "row mt-2" }
const _hoisted_11 = {
  for: "receiptForwardMode",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_12 = { class: "col-sm-8" }
const _hoisted_13 = ["value"]
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "row mt-2" }
const _hoisted_16 = {
  for: "receiptForwardComment",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_17 = { class: "col-sm-8" }
const _hoisted_18 = { class: "text-muted" }
const _hoisted_19 = { class: "row mt-2" }
const _hoisted_20 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_21 = { class: "col-sm-8" }
const _hoisted_22 = { class: "mb-2" }
const _hoisted_23 = ["onUpdate:modelValue", "placeholder"]
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "text-muted" }
const _hoisted_26 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_27 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_28 = { class: "col-sm-8" }
const _hoisted_29 = ["value", "id"]
const _hoisted_30 = ["for"]
const _hoisted_31 = { class: "pt-2" }
const _hoisted_32 = { class: "text-muted small mb-3" }
const _hoisted_33 = { class: "row mt-2" }
const _hoisted_34 = {
  for: "tgReceiptActionsGroupId",
  class: "col-sm-4 col-form-label text-capitalize-first"
}
const _hoisted_35 = { class: "col-sm-8" }
const _hoisted_36 = { class: "text-muted" }
const _hoisted_37 = { class: "row mt-2" }
const _hoisted_38 = { class: "col-sm-4 col-form-label text-capitalize-first" }
const _hoisted_39 = { class: "col-sm-8" }
const _hoisted_40 = ["value", "id"]
const _hoisted_41 = ["for"]
const _hoisted_42 = { class: "d-flex justify-content-between w-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.helper.trans('labels.receipt_tg_bot_settings_title'),
    "dialog-class": "modal-lg",
    modelValue: _ctx.isOpen,
    "body-class": "pt-0",
    "onUpdate:modelValue": _cache[11] || (_cache[11] = (open) => !open && _ctx.cancel())
  }, {
    default: _withCtx(() => [
      (_ctx.draft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("ul", _hoisted_2, [
              _createElementVNode("li", _hoisted_3, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link text-capitalize-first", { active: _ctx.activeTab === _ctx.ReceiptSettingsTab.forward }]),
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.activeTab = _ctx.ReceiptSettingsTab.forward), ["prevent"]))
                }, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_tab_classic')), 3)
              ]),
              _createElementVNode("li", _hoisted_4, [
                _createElementVNode("a", {
                  class: _normalizeClass(["nav-link text-capitalize-first", { active: _ctx.activeTab === _ctx.ReceiptSettingsTab.interactive }]),
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.activeTab = _ctx.ReceiptSettingsTab.interactive), ["prevent"]))
                }, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_tab_interactive')), 3)
              ])
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_section_classic_lead')), 1),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.tg_receipt_forward_group_id')), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors('tgReceiptForwardGroupId')
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        id: 'tgReceiptForwardGroupId',
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.draft.tgReceiptForwardGroupId) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control", parentProps.class])
                      }, null, 2), [
                        [_vModelText, _ctx.draft.tgReceiptForwardGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_mode')), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors('receiptForwardMode')
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("select", {
                        id: "receiptForwardMode",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.draft.receiptForwardMode) = $event)),
                        class: _normalizeClass(["form-select", parentProps.class])
                      }, [
                        _createElementVNode("option", {
                          value: _ctx.ReceiptForwardMode.FULL
                        }, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_mode_full')), 9, _hoisted_13),
                        _createElementVNode("option", {
                          value: _ctx.ReceiptForwardMode.REDACTED
                        }, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_mode_redacted')), 9, _hoisted_14)
                      ], 2), [
                        [_vModelSelect, _ctx.draft.receiptForwardMode]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"])
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_comment')), 1),
                _createElementVNode("div", _hoisted_17, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors('receiptForwardComment')
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("textarea", {
                        id: "receiptForwardComment",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.draft.receiptForwardComment) = $event)),
                        class: _normalizeClass(["form-control", parentProps.class]),
                        rows: "3"
                      }, null, 2), [
                        [_vModelText, _ctx.draft.receiptForwardComment]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_18, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_comment_hint')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_target_chats')), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.draft.receiptForwardTargetChatIds, (chatId, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "d-flex flex-row align-items-center gap-2 mb-2"
                      }, [
                        _createVNode(_component_FormInputWrapper, {
                          errors: _ctx.getErrors(`receiptForwardTargetChatIds.${index}`),
                          class: "flex-grow-1"
                        }, {
                          default: _withCtx((parentProps) => [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": ($event: any) => ((_ctx.draft.receiptForwardTargetChatIds[index]) = $event),
                              type: "text",
                              class: _normalizeClass(["form-control", parentProps.class]),
                              placeholder: _ctx.helper.trans('labels.receipt_forward_target_chat_placeholder', {number: index + 1})
                            }, null, 10, _hoisted_23), [
                              [_vModelText, _ctx.draft.receiptForwardTargetChatIds[index]]
                            ])
                          ]),
                          _: 2
                        }, 1032, ["errors"]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-danger btn-sm flex-shrink-0",
                          onClick: ($event: any) => (_ctx.removeTargetChat(index))
                        }, _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                        ]), 8, _hoisted_24)
                      ]))
                    }), 128)),
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-outline-primary btn-sm",
                      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addTargetChat && _ctx.addTargetChat(...args)))
                    }, [
                      _cache[13] || (_cache[13] = _createElementVNode("i", { class: "fa fa-plus" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.helper.trans('labels.receipt_forward_add_chat')), 1)
                    ])
                  ]),
                  _createElementVNode("small", _hoisted_25, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_target_chats_hint')), 1)
                ])
              ]),
              (_ctx.draft.receiptForwardMode === _ctx.ReceiptForwardMode.REDACTED)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_fields')), 1),
                    _createElementVNode("div", _hoisted_28, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RECEIPT_FORWARD_FIELD_CATALOG, (field) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: field.key,
                          class: "form-check small mb-1"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            value: field.key,
                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.draft.receiptForwardFields) = $event)),
                            id: `receiptForwardField_${field.key}`
                          }, null, 8, _hoisted_29), [
                            [_vModelCheckbox, _ctx.draft.receiptForwardFields]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: `receiptForwardField_${field.key}`
                          }, _toDisplayString(_ctx.helper.trans(`labels.${field.label}`)), 9, _hoisted_30)
                        ]))
                      }), 128))
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 512), [
              [_vShow, _ctx.activeTab === _ctx.ReceiptSettingsTab.forward]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_section_interactive_lead')), 1),
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.helper.trans('labels.tg_receipt_actions_group_id')), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_FormInputWrapper, {
                    errors: _ctx.getErrors('tgReceiptActionsGroupId')
                  }, {
                    default: _withCtx((parentProps) => [
                      _withDirectives(_createElementVNode("input", {
                        id: "tgReceiptActionsGroupId",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.draft.tgReceiptActionsGroupId) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control", parentProps.class])
                      }, null, 2), [
                        [_vModelText, _ctx.draft.tgReceiptActionsGroupId]
                      ])
                    ]),
                    _: 1
                  }, 8, ["errors"]),
                  _createElementVNode("small", _hoisted_36, _toDisplayString(_ctx.helper.trans('labels.tg_receipt_actions_group_id_hint')), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.helper.trans('labels.receipt_forward_actions')), 1),
                _createElementVNode("div", _hoisted_39, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleReceiptActions, (action) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: action.key,
                      class: "form-check small mb-1"
                    }, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        value: action.key,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.draft.receiptForwardActions) = $event)),
                        id: `receiptForwardAction_${action.key}`
                      }, null, 8, _hoisted_40), [
                        [_vModelCheckbox, _ctx.draft.receiptForwardActions]
                      ]),
                      _createElementVNode("label", {
                        class: "form-check-label",
                        for: `receiptForwardAction_${action.key}`
                      }, _toDisplayString(_ctx.helper.trans(`labels.${action.label}`)), 9, _hoisted_41)
                    ]))
                  }), 128))
                ])
              ])
            ], 512), [
              [_vShow, _ctx.activeTab === _ctx.ReceiptSettingsTab.interactive]
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_42, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary btn-sm text-capitalize-first",
          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
        }, _toDisplayString(_ctx.helper.trans('button.cancel')), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-primary btn-sm text-capitalize-first",
          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
        }, _toDisplayString(_ctx.helper.trans('button.save')), 1)
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}